import axios from "axios";
import { USER, USER_ID } from "./Apis";

export const getUserList = () => {
    return axios.get(USER);
};

export const addUser = (body) => {
    return axios.post(USER, body);
}

export const updateUser = (id,body) =>{
    return axios.put(`${USER}/${id}`, body);
}

export const deleteUser = (id) => {
    return axios.delete(USER_ID(id));
}

export const getUserInfo = (id) => {
    return axios.get(`${USER}/${id}`)
}

export const UpdatePassword = (data) =>{
    return axios.put(`${USER}/updatePassword`, data)
}